var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFindAnOffice = function SvgFindAnOffice(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 26,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10 .5C4.486.5 0 4.986 0 10.494-.036 18.55 9.62 25.23 10 25.5c0 0 10.036-6.95 10-15 0-5.514-4.486-10-10-10m0 15c-2.762 0-5-2.238-5-5s2.238-5 5-5 5 2.238 5 5-2.237 5-5 5"
  })));
};
export default SvgFindAnOffice;